import { h } from 'preact';
import style from './SecureTransferFooter.sass';
import wompiLogo from '../../assets/pago-seguro-wompi-desktop.svg';
import financialInstitutionLogo from '../../assets/grupo-cibest-primary.svg';

export default function SecureTransferFooter() {
  return (
    <div className={style.container}>
      <img
        className={`${style.financialInstitution} ${style.desktop}`}
        src={financialInstitutionLogo}
        alt='Bancolombia'
      />
      <img className={style.logo} src={wompiLogo} alt={'Wompi'} />
    </div>
  );
}
